<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <notifications
        classes="app-notify"
        :duration="5000"
        :width="600"
        animation-name="v-fade-left"
        position="top right"
      >
      </notifications>
      <reset-password-card header-color="green">
        <h4 slot="title" class="title">{{ $t("user.forgot_password") }}</h4>
        <p slot="action-title" class="action-title">
          {{ $t("user.email_forgot_password") }}
        </p>
        <p slot="description" class="description">
          {{ $t("user.rule_reset_password") }}
        </p>
        <div slot="form-submit">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(submit)">
              <div class="md-layout" style="text-align: left">
                <!--  new password   -->
                <div class="md-layout-item md-size-100">
                  <label
                    class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"
                    style="padding: 0"
                  >
                    {{ $t("user.new_password") }}
                  </label>
                  <ValidationProvider
                    vid="newPassword"
                    :name="$t('user.new_password')"
                    rules="required|strongPassword"
                    v-slot="{ passed, failed, errors }"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <md-input
                        v-model="params.password"
                        type="password"
                        name="newPassword"
                      ></md-input>

                      <slide-y-down-transition>
                        <md-icon class="error" v-show="failed">close</md-icon>
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon class="success" v-show="passed">done</md-icon>
                      </slide-y-down-transition>
                    </md-field>
                    <div class="validate-error">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>

                <!--  new password confirm   -->
                <div class="md-layout-item md-size-100">
                  <label
                    class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"
                    style="padding: 0"
                  >
                    {{ $t("user.new_password_confirm") }}
                  </label>
                  <ValidationProvider
                    :name="$t('user.new_password_confirm')"
                    rules="required|confirmed:newPassword"
                    v-slot="{ passed, failed, errors }"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <md-input
                        v-model="params.password_confirm"
                        type="password"
                        name="password_confirm"
                      ></md-input>

                      <slide-y-down-transition>
                        <md-icon class="error" v-show="failed">close</md-icon>
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon class="success" v-show="passed">done</md-icon>
                      </slide-y-down-transition>
                    </md-field>
                    <div class="validate-error">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
              <md-card-actions class="text-center">
                <md-button
                  type="submit"
                  class="md-success"
                  style="margin-right: 10px;"
                >
                  {{ $t("user.reset_mail") }}
                </md-button>
              </md-card-actions>
            </form>
          </ValidationObserver>
        </div>
      </reset-password-card>
    </div>
  </div>
</template>

<script>
import { ResetPasswordCard } from "@/components";
import { SlideYDownTransition } from "vue2-transitions";
import { AuthService } from "../../../services/auth.service";

export default {
  name: "ResetPassword",
  components: {
    ResetPasswordCard,
    SlideYDownTransition
  },
  data() {
    return {
      params: {
        password: null,
        password_confirm: null
      }
    };
  },
  methods: {
    submit() {
      this.forgotPassword();
    },
    async forgotPassword() {
      const response = await AuthService.forgotPassword({
        ...this.params,
        token: this.$route.query.token
      });
      if (!response) {
        return;
      }
      this.$notify({
        title: this.$t("user.updated"),
        text: this.$t("user.reset_pass_text"),
        type: "success"
      });
      setTimeout(() => this.$router.push({ name: "Login" }), 1000);
    }
  }
};
</script>

<style scoped></style>
